const joyRideTourComplete = (state) => {
  return state && state.status !== "running" && state.lifecycle === "complete";
};

export default joyRideTourComplete;
